
import { defineComponent, ref, PropType, onMounted, inject } from "vue";
import { useRouter } from "vue-router";

//  utils
import api from "@/api/axios";
import Toast from "@/components/UI/Toast/";
import { nextTick } from "q";
import $ from "jquery";
import RedPackage from "@/components/common/RedPackage.vue";

export default defineComponent({
  name: "product",
  /*components: { RedPackage },*/
  setup() {
    //  展示用户信息
    const userInfo = inject("userInfo") as any;
    const router = useRouter();
    const DPnumber = ref("");
    const DPzufen = ref("");
    const DPnondu = ref("");
    const DUname = ref<string>(userInfo.realName);
    const DPguige = ref("");
    const DUcontact = ref<string>(userInfo.mobile);
    // const DPbeizhu = ref("");
    const code = ref("");

    // let DPzufenDom = {} as HTMLInputElement;
    // const setDPzufen = (el: HTMLInputElement) => {
    //   DPzufenDom = el;
    // };

    /*const showRedPackage = ref(false);*/
    function handlePostAdd() {
      nextTick(() => {
        if (DPzufen.value.length < 1) {
          Toast({
            title: "请输入待定制产品的组分",
            type: "warning",
          });
          $("#DPzufen").focus();
          return false;
        }
        if (DPzufen.value.length > 100) {
          Toast({
            title: "产品的组分不能超过100个字符",
            type: "warning",
          });
          $("#DPzufen").focus();
          return false;
        }
        if (DPnondu.value.length < 1) {
          Toast({
            title: "请输入待定制产品的标准值",
            type: "warning",
          });
          $("#DPnondu").focus();
          return false;
        }
        if (DPnondu.value.length > 100) {
          Toast({
            title: "产品的标准值不能超过100个字符",
            type: "warning",
          });
          $("#DPnondu").focus();
          return false;
        }
        if (DPguige.value.length < 1) {
          Toast({
            title: "请输入待定制产品的规格",
            type: "warning",
          });
          $("#DPguige").focus();
          return false;
        }
        if (DPguige.value.length > 100) {
          Toast({
            title: "产品的规格不能超过100个字符",
            type: "warning",
          });
          $("#DPguige").focus();
          return false;
        }
        if (DPnumber.value.length < 1) {
          Toast({
            title: "请输入待定制产品的数量",
            type: "warning",
          });
          $("#DPnumber").focus();
          return false;
        }
        if (Number(DPnumber.value) < 1) {
          Toast({
            title: "数量需大于0",
            type: "warning",
          });
          $("#DPnumber").val("").focus();
          return false;
        }
        if (DPnumber.value.length > 10) {
          Toast({
            title: "产品的数量不能超过10个字符",
            type: "warning",
          });
          $("#DPnumber").focus();
          return false;
        }

        if (userInfo.mobile) {
          if (!userInfo.realName) {
            DUname.value = userInfo.nickName
          }
        } else {
          if (
            (DUname.value && DUname.value.length < 2 && DUname.value.length > 15) ||
            !DUname.value
          ) {
            Toast({
              title: "请输入合法姓名",
              type: "warning",
            });
            $("#DUname").focus();
            return false;
          }
        }

        if (userInfo.mobile) {
          DUcontact.value = userInfo.mobile
        } else {
          if ((DUcontact.value && DUcontact.value.length > 20) || (DUcontact.value && DUcontact.value.length < 1) || !DUcontact.value) {
            Toast({
              title: "请输入合法联系方式",
              type: "warning",
            });
            $("#DUcontact").focus();
            return false;
          }
        }

        if (!code.value && code.value.length < 1) {
          Toast({
            title: "请输入验证码",
            type: "warning",
          });
          $("#code").focus();
          return false;
        }

        // if (DPbeizhu.value.length > 255) {
        //   Toast({
        //     title: "备注不能超过255个字符",
        //     type: "warning",
        //   });
        //   $("#DPbeizhu").focus();
        //   return false;
        // }
        const formData = new FormData();
        formData.append("DPnumber", DPnumber.value);
        formData.append("DPnondu", DPnondu.value);
        formData.append("DUname", DUname.value);
        formData.append("DPzufen", DPzufen.value);
        formData.append("DPguige", DPguige.value);
        formData.append("DUcontact", DUcontact.value);
        // formData.append("DPbeizhu", DPbeizhu.value);
        formData.append("Code", code.value);
        api
          .post("/M/Server/DoSubmitDingzhi", formData)
          .then((res) => {
            if (res.data.success) {
              Toast({
                title: res.data.msg,
                type: "success",
                onClose: () => {
                  // router.push("/product");
                },
              });
             /* showRedPackage.value = true;*/
              DPnumber.value = "";
              DPzufen.value = "";
              DPnondu.value = "";
              DUname.value = "";
              DPguige.value = "";
              DUcontact.value = "";
              // DPbeizhu.value = "";
              code.value = "";
            } else {
              Toast({
                title: res.data.msg,
                type: "warning",
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      });
    }

    const codeImg = ref("/M/Server/GetVerifyCodeImg");

    function getCodeImg() {
      codeImg.value = "/M/Server/GetVerifyCodeImg?random=" + Math.random();
    }

    function handleBack() {
      if (window.history.length <= 1) {
        router.push({ path: "/" });
      } else {
        router.back();
      }
    }

/*    function onOpenPackage() {
      showRedPackage.value = false;
    }*/
    return {
      DPnumber,
      DPnondu,
      DUname,
      DPzufen,
      DPguige,
      DUcontact,
      // DPbeizhu,
      code,
      handleBack,
      handlePostAdd,
      codeImg,
      getCodeImg,
/*      onOpenPackage,
      showRedPackage,*/
      userInfo
    };
  },
});
